"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var collection_header_store_1 = require("./stores/collection_header_store");
var seo_blurb_1 = require("@reverbdotcom/commons/dist/cms/components/seo_blurb");
var CollectionSEOContent = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionSEOContent, _super);
    function CollectionSEOContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collectionHeader: collection_header_store_1.CollectionHeaderStore.getState().collectionHeader || {},
        };
        _this.onCollectionHeaderStoreUpdated = _this.onCollectionHeaderStoreUpdated.bind(_this);
        return _this;
    }
    CollectionSEOContent.prototype.componentDidMount = function () {
        collection_header_store_1.CollectionHeaderStore.listen(this.onCollectionHeaderStoreUpdated);
    };
    CollectionSEOContent.prototype.componentWillUnmount = function () {
        collection_header_store_1.CollectionHeaderStore.unlisten(this.onCollectionHeaderStoreUpdated);
    };
    CollectionSEOContent.prototype.onCollectionHeaderStoreUpdated = function () {
        this.setState({
            collectionHeader: collection_header_store_1.CollectionHeaderStore.getState().collectionHeader,
        });
    };
    CollectionSEOContent.prototype.render = function () {
        if (!this.state.collectionHeader) {
            return null;
        }
        var descriptionHTML = this.state.collectionHeader.description;
        if (!descriptionHTML) {
            return null;
        }
        return (React.createElement(seo_blurb_1.default, { contentHtml: descriptionHTML, withWrapper: true }));
    };
    return CollectionSEOContent;
}(React.Component));
exports.default = CollectionSEOContent;
//# sourceMappingURL=collection_seo_content.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/collection_seo_content.js
// module id = WKb3
// module chunks = 20 21